import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import EditCustomerSchool from './EditCustomerSchool'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'

export default {
  props: {
    value: {
      default: undefined
    },
    getuseronly: {
      default: false
    },
    pageid: {
      default: undefined
    },
    loaduser: {
      default: true
    },
    group_id: {
      default: false
    },
    is_leave_group: {
      default: false
    },
    is_blocked: {
      default: false
    }
  },
  data: function() {
    return {
      loading: true,
      dialogMember: false,
      user: {},
      isEditTag: false,
      isEditSession: false,
      userDataSession: [],
      isEditNickname: false,
      usertag: '',
      profile_pic: '',
      currentpageid: null,
      userSession: null,
      isCreateBill: false,
      tagOptions: [],
      statusOptions: [],
      loadingCreatebill: false,
      customerNickname: '',
      cachedCustomerNickname: ''
    }
  },
  components: {
    CustomerItemValue,
    EditCustomerValue,
    EditCustomerSchool,
    specialtext,
    Tags
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      currentLang: 'currentLang',
      memberGroup: 'getMemberGroup',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      userTags: 'getUserTags',
      loadingUserTags: 'getLoadingUserTags'
    }),
    contextOptions() {
      return [
        {
          label: this.$t('contactadmin'),
          value: 'contactadmin'
        }
      ]
    },
    questionmessages() {
      if (this.value && this.$store.state.niveapage.includes(this.currentpageid)) {
        return this.value.questionmessages.split(';;')
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.currentpageid)
    },
    filterIntent: function() {
      var vm = this
      if (!vm.user.intentlist) return []
      return vm.user.intentlist.sort(function(a, b) {
        if (parseInt(a.count) > parseInt(b.count)) {
          return -1
        }

        if (parseInt(a.count) < parseInt(b.count)) {
          return 1
        }

        return 0
      })
    },
    userLocale: function() {
      var vm = this
      return config.locale.find(function(locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function() {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  mounted: async function() {
    this.getUserTagList()
    this.getUserStatusList()

    if (this.pageid) {
      this.currentpageid = this.pageid
    } else {
      this.currentpageid = this.selectedBot.pageid
    }
    this.getuserDetail()
    if (this.group_id) {
      this.groupMemebers()
    }
    this.user = this.value
    this.cached_tag = this.user.tags
  },
  methods: {
    cancelEdit: function() {
      const vm = this
      vm.isEditNickname = false
      vm.customerNickname = vm.cachedCustomerNickname
    },
    saveEdit: async function() {
      const vm = this
      var data = {
        app: vm.user.app,
        userid: vm.user.id,
        nickname: vm.customerNickname
      }
      let res = await vm.post(
        `page/${
          vm.$route.name == 'allinonechat' ? vm.$store.state.livechat.pageid : vm.selectedBot.pageid
        }/set-user-nickname`,
        data
      )
      if (res.success) {
        vm.isEditNickname = false
      } else {
        vm.$swal.fire({
          title: vm.$t('Something went wrong. Please try it again later'),
          type: 'error',
          confirmButtonText: vm.$t('Confirm'),
          showCancelButton: false,
          reverseButtons: true
        })
      }
    },
    async shoplink(type) {
      const vm = this
      let url = ''
      const pageId =
        vm.$route.name == 'allinonechat' ? vm.$store.state.livechat.pageid : vm.selectedBot.pageid
      if (
        [
          'localhost',
          'cms.zwiz.app',
          'cms.zwiz.ai',
          'localhost:3000',
          'cmstest.zwiz.ai',
          'cmstest.zwiz.app',
          'cmstest1.zwiz.ai',
          'cmstest2.zwiz.ai',
          'cmstest3.zwiz.ai',
          'staging.d1ft7fytzib0ll.amplifyapp.com'
        ].includes(window.location.hostname)
      ) {
        const data = {
          pageId: pageId,
          body: { userid: vm.user.id }
        }
        vm.loadingCreatebill = true
        let windowReference = window.open(
          '',
          'hello',
          type === 'newVersion' ? 'width=500,height=500' : ''
        )
        const res = await api.generateAdminToken(data)
        if (res.success && res.result) {
          if (type === 'newVersion') {
            url = `https://shopv2.zwiz.app/ecommerce/${pageId}?userid=${vm.user.id}&sessiontoken=${vm.user.sessiontoken}&shoptoken=${res.result.shop_token}&lang=${vm.currentLang}&category=all&from=livechat`
          } else {
            url = `https://shopv2.zwiz.app/ecommerce/${pageId}?userid=${vm.user.id}&sessiontoken=${vm.user.sessiontoken}&lang=${vm.currentLang}&category=all&from=livechat`
          }
          windowReference.location = url
        }
      } else if (window.location.href.includes('enterprise.zwiz.ai')) {
        url = `https://shopcommu.zwiz.app/ecommerce/${pageId}?userid=${vm.user.id}&sessiontoken=${vm.user.sessiontoken}&lang=${vm.currentLang}&category=all&from=livechat`
        window.open(url, '_blank')
      } else {
        return false
      }
      vm.loadingCreatebill = false
    },
    goToAllInOneChat() {
      var query = { userid: this.user.id, app: this.user.app }
      this.$router
        .push({
          name: 'allinonechat',
          path: '/allinonechat',
          query: query
        })
        .catch(() => {})
    },
    isModular(group_id) {
      return group_id.includes('LC', 0)
    },
    async leaveGroup() {
      let result = await this.$swal.fire({
        title: this.$t('Warning!'),
        text: this.$t('Are you sure you want to leave this group?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        var data = {
          groupId: this.group_id,
          pageId: this.pageid
        }
        var response = await api.leaveGroup(data)
        if (response) {
          this.getuserDetail()
          this.$store.dispatch('updateBotDetail')
          await this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
        }
      }
    },

    async blockGroup(type) {
      if (type === 'block') {
        let result = await this.$swal.fire({
          title: this.$t('Warning!'),
          text: this.$t(
            'When you block this group, you will no longer be able to receive chat messages or stored after this.'
          ),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          this.blockGroupApi(type)
        }
      } else {
        this.blockGroupApi(type)
      }
    },

    async blockGroupApi(type) {
      var data = {
        groupId: this.group_id,
        pageId: this.pageid,
        type: type
      }
      var response = await api.blockGroup(data)
      if (response) {
        this.getuserDetail()
        this.$store.dispatch('updateBotDetail')
        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })
      }
    },
    async getUserTagList() {
      const vm = this

      await vm.$store.dispatch('loadTags')
      if (vm.userTags.length > 0) {
        vm.tagOptions = vm.userTags.map(item => {
          return item.name
        })
      }
    },
    async getUserStatusList() {
      const vm = this

      await vm.$store.dispatch('loadStatus')
      if (vm.userStatus.length > 0) {
        vm.statusOptions = vm.userStatus.map(item => {
          return item.name
        })
      }
    },
    openGroupBill(user) {
      var url = ''
      if (
        [
          'localhost',
          'cms.zwiz.app',
          'cms.zwiz.ai',
          'localhost:3000',
          'cmstest.zwiz.ai',
          'cmstest1.zwiz.ai',
          'cmstest2.zwiz.ai',
          'cmstest3.zwiz.ai'
        ].includes(window.location.hostname)
      ) {
        url = 'https://shopv2.zwiz.app'
      } else if (window.location.href.includes('enterprise.zwiz.ai')) {
        url = 'https://shopcommu.zwiz.app'
      } else {
        return false
      }
      var pageid =
        this.$route.name == 'allinonechat'
          ? this.$store.state.livechat.pageid
          : this.selectedBot.pageid
      var url =
        url +
        `/ecommerce/${pageid}?userid=${user.userid}__${pageid}&group_id=${user.group_id}&sessiontoken=${user.sessiontoken}&lang=${this.currentLang}&category=all&from=livechat`
      window.open(url, '_blank')
    },
    async groupMemebers() {
      var vm = this
      var response = await api.groupMemebers({ group_id: this.group_id })
      if (response.success) {
        vm.$store.dispatch('setMemberGroup', response.result)
      }
    },
    toggleBotStatus: async function() {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    },
    getuserDetail() {
      let vm = this
      let data = {
        pageid: vm.currentpageid,
        userid: vm.value.userid || vm.value.id,
        more_fields: 'intentlist'
      }
      if (!this.loaduser) {
        vm.loading = false
        vm.user = vm.value
        vm.customerNickname = vm.user.nickname
        vm.cachedCustomerNickname = vm.user.nickname
        vm.setUserSession(vm.user.session)
      } else if (this.getuseronly) {
        api.getuserCustomerOnly(data, function(error, response) {
          if (error) console.error(error)
          vm.user = response.data[0]
          vm.customerNickname = vm.user.nickname
          vm.cachedCustomerNickname = vm.user.nickname
          vm.setUserSession(vm.user.session)
          vm.loading = false
        })
      } else {
        api.getuserCustomer(data, function(error, response) {
          if (error) console.error(error)
          vm.user = response.data[0]
          vm.customerNickname = vm.user.nickname
          vm.cachedCustomerNickname = vm.user.nickname
          vm.setUserSession(vm.user.session)
          vm.loading = false
        })
      }
    },
    setUserSession(session) {
      if (session) {
        try {
          let data = []
          this.userSession = JSON.parse(session)
          for (const key in this.userSession) {
            const transformedObject = {
              key: key,
              value: this.userSession[key]
            }
            data.push(transformedObject)
          }
          this.userDataSession = data
        } catch (e) {
          this.userSession = session
        }
      } else {
        this.userSession = {}
      }
    },
    setUserDataSession(session) {
      const outputArray = []
      for (const key in session) {
        const transformedObject = {
          key: key,
          value: session[key]
        }
        outputArray.push(transformedObject)
      }
      this.userDataSession = outputArray
    },
    editSession() {
      var vm = this
      vm.$store.dispatch('loading')
      const sessionObj = {}
      for (let item of this.userDataSession) {
        if (item.key) {
          sessionObj[item.key] = item.value || ''
        }
      }
      const data = {
        params: {
          pageid: vm.currentpageid
        },
        body: {
          usersid: this.user.id,
          session: Object.keys(sessionObj).length === 0 ? '' : sessionObj
        }
      }
      api.saveusersession(data, (error, response) => {
        if (response.responsecode == 200) {
          vm.$store.dispatch('loading')
          this.isEditSession = false
          this.setUserDataSession(sessionObj)
          this.setUserSession(sessionObj)
          vm.$forceUpdate()
        }
        if (error) {
          vm.$store.dispatch('loading')
          vm.$swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'กรุณาลองใหม่อีกครั้ง',
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        }
      })
    },
    deleteSession(key, index) {
      this.userDataSession = this.userDataSession.filter((item, i) => i !== index)
      this.isEditSession = false
      this.isEditSession = true
    },
    addUserSession() {
      this.userDataSession.unshift({
        '': '',
        '': ''
      })
    },
    cancleEditSession() {
      this.setUserSession(this.userSession)
      this.setUserDataSession(this.userSession)
      this.isEditSession = false
    },
    onEditAddress(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        address: payload.customer_value || ''
      }
      api.saveUserAddress(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    async onEditContext(payload) {
      var vm = this
      if (this.group_id) {
        vm.$store.dispatch('loading')
        var dataGroup = {
          group_id: this.group_id,
          value: {
            context: payload.customer_value || ''
          }
        }
        var res = await api.editGroupInfo(dataGroup)
        if (res.success) {
          vm.$store.dispatch('loading')
          payload.onEdit()
        } else {
          vm.$store.dispatch('loading')
        }
      } else {
        vm.$store.dispatch('loading')
        var data = {
          pageid: payload.pageid,
          usersid: payload.usersid,
          context: payload.customer_value || ''
        }
        api.saveUserContext(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
          }
          vm.$store.dispatch('loading')
          payload.onEdit()
        })
      }
    },
    async onEditNote(payload) {
      var vm = this
      if (this.group_id) {
        vm.$store.dispatch('loading')
        var dataGroup = {
          group_id: this.group_id,
          value: {
            note: payload.customer_value || ''
          }
        }
        var res = await api.editGroupInfo(dataGroup)
        if (res.success) {
          vm.$store.dispatch('loading')
          payload.onEdit()
        } else {
          vm.$store.dispatch('loading')
        }
      } else {
        vm.$store.dispatch('loading')
        var data = {
          pageid: payload.pageid,
          usersid: payload.usersid,
          context: payload.customer_value || ''
        }
        api.saveUserNote(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
          }
          vm.$store.dispatch('loading')
          payload.onEdit()
        })
      }
    },
    saveEditTag: async function() {
      var vm = this
      if (this.group_id) {
        vm.$store.dispatch('loading')
        var dataGroup = {
          group_id: this.group_id,
          value: {
            tags: vm.user.tags || ''
          }
        }
        var res = await api.editGroupInfo(dataGroup)
        if (res.success) {
          vm.cached_tag = vm.user.tags
          vm.$emit('input', vm.user)
          vm.isEditTag = false
          vm.$store.dispatch('loading')
        } else {
          vm.$store.dispatch('loading')
        }
      } else {
        vm.$store.dispatch('loading')
        var data = {
          pageid: vm.currentpageid,
          usersid: vm.user.id,
          tags: vm.user.tags || ''
        }
        api.saveUserTags(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
          }
          vm.$emit('input', vm.user)
          vm.cached_tag = vm.user.tags
          vm.isEditTag = false
          vm.$store.dispatch('loading')
        })
      }
    },
    cancelEditTag: function() {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function() {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: async function(payload) {
      var vm = this
      if (this.group_id) {
        vm.$store.dispatch('loading')
        var dataGroup = {
          group_id: this.group_id,
          value: {
            status: payload.customer_value || ''
          }
        }
        var res = await api.editGroupInfo(dataGroup)
        if (res.success) {
          vm.$store.dispatch('loading')
          payload.onEdit()
        } else {
          vm.$store.dispatch('loading')
        }
      } else {
        vm.$store.dispatch('loading')
        var data = {
          pageid: payload.pageid,
          usersid: payload.usersid,
          status: payload.customer_value || ''
        }
        api.saveUserStatus(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
          }
          vm.$store.dispatch('loading')
          payload.onEdit()
        })
      }
    },
    onEditLineId: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        lineid: payload.customer_value || ''
      }
      api.saveUserLineId(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditSchool: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        school: payload.customer_value || ''
      }
      api.saveUserSchool(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditProvince: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        province: payload.customer_value || ''
      }
      api.saveUserProvince(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value || ''
      }
      api.saveUserEmail(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value || ''
      }
      api.saveUserPhoneno(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  },
  watch: {
    // value: function() {
    //   this.user = this.value
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/analytics/CustomerDetail.js